import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Refrigerator } from "lucide-react";
import { useShoppingList } from "../contexts/ShoppingListContext";
import { MealSuggestionApi } from "../api/MealSuggestionApi";
import { AiFreeTextInputCard } from "../components/MealSuggestions/AiFreeTextInputCard";
import { MealSuggestionCard } from "../components/MealSuggestions/MealSuggestionCard";

const LOADING_PHRASES = [
  "Sniffing out what's in your fridge...",
  "Matching ingredients to recipes...",
  "Minimizing your next grocery run...",
  "Rescuing that wilting spinach...",
];

export function FridgePage() {
  const navigate = useNavigate();
  const { addItemsToShoppingList } = useShoppingList();
  const [suggestions, setSuggestions] = useState(null);

  const handleGenerate = async (text) => {
    const results = await MealSuggestionApi.suggestMeals(text);
    setSuggestions(results);
  };

  const handleSaveRecipe = (suggestion) => {
    navigate("/CreateMeal", { state: { aiDraft: suggestion } });
  };

  const handleAddMissingToList = (suggestion) => {
    const missingItems = suggestion.ingredients
      .filter((ing) => !ing.onHand)
      .map((ing) => ({
        itemName: ing.name,
        itemQuantity: ing.quantity,
        itemUnit: ing.unit,
      }));
    return addItemsToShoppingList(missingItems);
  };

  return (
    <div className="h-full overflow-auto p-4 sm:p-8">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-2 mb-1">
          <Refrigerator className="w-6 h-6 text-gray-900" />
          <h1 className="text-2xl sm:text-3xl font-semibold text-gray-900">
            Fridge
          </h1>
        </div>
        <p className="text-sm text-gray-500 mb-6">
          Tell us what's in your fridge and we'll suggest what to cook
        </p>

        <AiFreeTextInputCard
          label="What do you have?"
          placeholder={`e.g. "chicken thighs, half a bag of spinach, rice, garlic, a bit of parmesan"`}
          loadingPhrases={LOADING_PHRASES}
          onGenerate={handleGenerate}
        />

        {suggestions && (
          <>
            <p className="text-xs font-medium text-gray-400 uppercase tracking-wide mb-3">
              Suggestions
            </p>
            {suggestions.length === 0 ? (
              <p className="text-sm text-gray-600">
                Couldn't find any meal ideas from that. Try adding a few more
                items.
              </p>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {suggestions.map((suggestion, index) => (
                  <MealSuggestionCard
                    key={index}
                    suggestion={suggestion}
                    onSaveRecipe={() => handleSaveRecipe(suggestion)}
                    onAddMissingToList={() => handleAddMissingToList(suggestion)}
                  />
                ))}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
